import React, { useState } from 'react'
import { Box } from '@chakra-ui/layout'
import { useTranslation } from 'react-i18next'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ImageGrid from './ImageGrid'
import TopMediaList from './TopMediaList'
import moment from 'moment'

interface Props {
  data: AnalyticsAPIResponse
  assetClass: "image" | "video" | "others"
  dateRange?: {
    startDate: Date
    endDate: Date
  }
}

const TopAssets = ({ data, assetClass, dateRange }: Props): React.ReactElement => {
  const { t } = useTranslation()
  const topAssetsData = assetClass === "image" ? data.topImages : (assetClass === "video" ? data.topVideos : data.topOthers)
  const showPreview = assetClass === "image" ? true : false
  let dataAvailable = false

  const [tabIndex, setTabIndex] = useState(0)

  let forceimagePreview = false

  if(dateRange?.startDate) {
    if(moment(dateRange.startDate).isAfter(moment("08/04/2023", "DD/MM/YYYY"))) {
      forceimagePreview = true
    }
  }

  if (
    topAssetsData &&
    Object.keys(topAssetsData).length > 0 &&
    topAssetsData.requestWise.length > 0 &&
    topAssetsData.bandwidthWise.length > 0
  ) {
    dataAvailable = true
  }

  if (!dataAvailable) {
    return <Box marginTop="1rem">{t('no_data_available', 'No Data Available')}</Box>
  }

  return (
    <Box marginTop="1rem">
      <Tabs
        variant="soft-rounded"
        size="sm"
        colorScheme="appBlue"
        index={tabIndex}
        onChange={setTabIndex}
      >
        <TabList>
          <Tab>{t('bandwidth_title_case', 'Bandwidth')}</Tab>
          <Tab>{t('request_title_case', 'Request')}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ImageGrid data={topAssetsData?.bandwidthWise} showPreview={showPreview} forceimagePreview={forceimagePreview} />
          </TabPanel>
          <TabPanel>
            <ImageGrid data={topAssetsData?.requestWise} showPreview={showPreview} forceimagePreview={forceimagePreview} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default TopAssets
